import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { Button } from "reactstrap";
import { FiSearch } from "react-icons/fi";
import { TiUserDelete } from "react-icons/ti";
import apiService from "services/api";
import { CustomAlert, CustomTable } from "components";
import { useNotificationContext } from "contexts";

const CoursePage = () => {
	const { data, isLoading, refetch } = useQuery("course", () =>
		apiService.course.get()
	);
	const { createNotification } = useNotificationContext();
	const [courseToDelete, setCourseToDelete] = useState({
		firstName: "",
		lastName: "",
		id: "",
	});

	const [displayConfirmationModal, setDisplayConfirmationModal] =
		useState(false);

	const showDeleteModal = (courseToDelete) => {
		setCourseToDelete(courseToDelete);
		setDisplayConfirmationModal(true);
	};

	// Hide the modal
	const hideConfirmationModal = () => {
		setDisplayConfirmationModal(false);
	};

	// Handle the actual deletion of the item
	const submitDelete = async () => {
		await apiService.course
			.delete(courseToDelete.id)
			.then(() => {
				createNotification({
					type: "success",
					message: "Successfully deleted course",
				});
				refetch();
			})
			.catch((error) =>
				createNotification({ type: "danger", message: error.message })
			);

		setDisplayConfirmationModal(false);
	};

	const columns = [
		{
			id: "courseName",
			Header: "Name",
			accessor: "name",
			sortable: true,
			filterable: true,
		},
		{
			id: "actions",
			Header: "actions",
			accessor: "actions",
			sortable: false,
			filterable: false,
		},
	];

	const actions = (row) => (
		<div className="actions-right">
			<Link to={`/course/view/${row.id}`}>
				<Button
					color="warning"
					size="sm"
					className="btn-icon btn-link edit"
				>
					<FiSearch size={20} />
				</Button>
			</Link>
			{/* <Button
                color="warning"
                size="sm"
                className="btn-icon btn-link edit"
                onClick={() => showDeleteModal(row)}
            >
                <TiUserDelete className="text-danger" size={20} />
            </Button> */}
		</div>
	);

	return (
		<div className="content">
			<div className="mt-3">
				<div className="d-flex mb-2">
					<Link to={`/course/new`}>
						<button type="button" className="btn btn-info">
							Add new course
						</button>
					</Link>
				</div>

				<CustomAlert
					title="Remove Member"
					show={displayConfirmationModal}
					hideModal={hideConfirmationModal}
					description={
						<>
							Are you sure you want to remove course{" "}
							<span className="text-danger font-weight-bold">
								{courseToDelete.name}?
							</span>
						</>
					}
					submitModal={submitDelete}
					submitButtonText="Delete"
				/>

				<CustomTable
					data={data}
					columns={columns}
					defaultPageSize={25}
					title="Courses"
					actions={actions}
					loading={isLoading}
				/>
			</div>
		</div>
	);
};

export default CoursePage;
